export const selectSearchQuery = state => state.people.peopleSearch.query;

export const selectSearchResults = state => state.people.peopleSearch.results;

export const selectIsSearch = state =>
  !!(selectSearchQuery(state) && selectSearchResults(state));
